const REVIEW_SOURCE = Object.freeze({
    none: '',
    default: 1,
    gmb: 2,
    zillow: 3,
    rma: 4
});
const REVIEW_SOURCE_KEY = Object.freeze({
    1: 'DEFAULT',
    2: 'GMB',
    3: 'ZILLOW',
    4: 'RMA'
});
const REVIEW_LOGO_ALT = Object.freeze({
    [REVIEW_SOURCE.zillow]: {
        src: 'https://cdn.chime.me/image/fs/sitebuild/2019918/22/original_c276097a-5262-4593-9371-749d884b85c5.png',
        alt: 'md-testimonial:md-testimonial.zillowLogo' //alt Due to internationalization translation ， So here the namespace is used for initialization
    },
    [REVIEW_SOURCE.gmb]: {
        src: 'https://static.chimeroi.com/servicetool-temp/2022511/18/fca51e28-d699-4dae-9bb2-4e68413af6db_googleMyBusiness.svg',
        alt: 'md-testimonial:md-testimonial.googleLogo' //alt Due to internationalization translation ， So here the namespace is used for initialization
    },
    [REVIEW_SOURCE.rma]: {
        lightSrc:
            'https://cdn.chime.me/image/fs/sitebuild/2023112/23/original_833ef94b-c125-411e-9163-323f68910aad.png',
        src: 'https://cdn.chime.me/image/fs/sitebuild/2023112/22/original_1d03b59e-6110-4d11-9cf7-17d122b2809f.png',
        alt: 'md-testimonial:md-testimonial.rmaLogo' //alt Due to internationalization translation ， So here the namespace is used for initialization
    }
});
export { REVIEW_SOURCE, REVIEW_SOURCE_KEY, REVIEW_LOGO_ALT };
